import React, { useState } from "react";

import green from "../images/green.svg";
import pink from "../images/pink.svg";
import white from "../images/white.svg";
import yellow from "../images/yellow.svg";
import orange from "../images/orange.svg";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Contact = ({ color }) => {
  const router = useNavigate();
  const [post, setPost] = useState({
    Email: "",
    Suggestion: "",
  });
  const handleInput = (e) => {
    setPost({ ...post, [e.target.name]: e.target.value });
  };
  const notify = () => {
    if (!post.Email.includes("@")) {
      toast.warn(
        `${
          !post.Email.includes("@")
            ? "Please enter a valid email!!"
            : "Some fields are missing"
        }`,
        {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        }
      );
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (post.Email !== "") {
      axios
        .post("https://api.web3forms.com/submit", {
          ...post,
          access_key: "681d278a-8b29-4560-8355-1b1338a80aa2",
        })
        .then((res) => {
          setPost({
            Email: "",
            Suggestion: "",
          });
          toast.success("Thank You! we received your form.", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        })
        .catch((err) => console.log(err));
    } else {
      notify();
      router("/join");
    }
  };
  return (
    <div className="">
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div className="base-wrapper mt-[100px] flex gap-[50px] md:flex-row flex-col-reverse relative">
        <div className="flex flex-col gap-[30px] md:w-[60%]">
          <h3 className="text-[#fff] text-[21px] font-[800]">
            Unlock a World of Fearless Expression and Limitless Connections
          </h3>
          <p className="text-[#A8A8A8] text-[15px] leading-[1.5] tracking-wider">
            Be First: Pre-register Now!
            <br />
            <br />
            Get ahead of the crowd and secure your spot in the INTROVERSE
            community. Pre-register now to be notified via email as soon as the
            app is launched. Early adopters can also participate in our User
            Experience Survey, helping us shape the future of INTROVERSE. Join
            the waitlist and be among the first to experience the next
            generation of social networking.
          </p>
        </div>
        <div className="form flex flex-col md:w-[40%] p-[30px] gap-[20px]">
          <div className="text-[12px] font-[800]">
            JOIN OUR WAITLIST AND GET REWARDS
          </div>
          <div className="text-[16px] text-[#A8A8A8] leading-[1.5] font-robo text-center">
            Register for early access
          </div>
          <form
            action=""
            className="flex flex-col gap-[20px] mt-[20px] relative"
          >
            <input
              type="email"
              value={post["Email"]}
              onChange={handleInput}
              className="w-full h-[50px] rounded-[10px] bg-[#D9D9D9] text-black font-rub uppercase px-[20px]"
              placeholder="Email"
              name="Email"
            />
            <input
              type="text"
              value={post["Suggestion"]}
              onChange={handleInput}
              className="w-full h-[50px] rounded-[10px] bg-[#D9D9D9] text-black font-rub uppercase px-[20px]"
              placeholder="Suggestion (Optional)"
              name="Suggestion"
            />
            <button
              type="submit"
              onClick={handleSubmit}
              className="btn mx-auto my-[20px]"
            >
              submit
            </button>
            <img
              src={
                color === "green"
                  ? green
                  : color === "white"
                  ? white
                  : color === "pink"
                  ? pink
                  : color === "orange"
                  ? orange
                  : yellow
              }
              alt=""
              className="absolute -z-10 scale-[1.8]"
            />
          </form>
        </div>
        <img
          src={
            color === "green"
              ? green
              : color === "white"
              ? white
              : color === "pink"
              ? pink
              : color === "orange"
              ? orange
              : yellow
          }
          alt=""
          className="absolute -z-10 -left-[350px] scale-[1]"
        />
      </div>
    </div>
  );
};

export default Contact;
